export function CashWithdrawalIcon(): JSX.Element {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      enableBackground="new 0 0 512 512"
    >
      <path d="m264,376.2v40.1c5.3-1 9.7-3.3 13-7.2 3.3-3.8 5-8.3 5-13.4 0-4.6-1.4-8.6-4.2-11.9-2.8-3.2-7.4-5.8-13.8-7.6z" />
      <path d="m234.8,324.8c0,3.6 1.1,7 3.4,10.1 2.3,3.1 5.7,5.6 10.3,7.6v-35.6c-4.2,1.4-7.5,3.7-10,7-2.5,3.2-3.7,6.9-3.7,10.9z" />
      <path d="m296.4,423.4c-7.8,8.5-18.6,13.7-32.5,15.6v19.2h-15.5v-18.7c-12.3-1.4-22.3-5.9-29.9-13.3-7.7-7.4-12.6-17.9-14.7-31.4l27.8-2.9c1.1,5.5 3.3,10.2 6.4,14.2 3.1,4 6.6,6.9 10.4,8.6v-43.1c-13.9-3.8-24.1-9.7-30.6-17.4-6.5-7.8-9.8-17.2-9.8-28.4 0-11.3 3.7-20.7 11-28.4 7.4-7.7 17.1-12.1 29.4-13.2v-10.2h15.6v10.2c11.3,1.3 20.3,5 27,11.2 6.7,6.1 10.9,14.4 12.8,24.6l-27,3.4c-1.6-8.1-5.9-13.6-12.8-16.5v40.2c17.1,4.5 28.7,10.2 34.9,17.3 6.2,7.1 9.3,16.2 9.3,27.3-0.1,12.8-4,23.2-11.8,31.7zm184.2-191.8h-449.2c-11.3,0-20.4,9.1-20.4,20.4v228.6c0,11.3 9.1,20.4 20.4,20.4h449.2c11.3,0 20.4-9.1 20.4-20.4v-228.6c5.68434e-14-11.3-9.1-20.4-20.4-20.4z" />
      <path
        opacity="0.7"
        d="m427,159h-342c-11.3,0-20.4,9.1-20.4,20.4 0,11.3 9.1,20.4 20.4,20.4h342c11.3,0 20.4-9.1 20.4-20.4 0-11.2-9.1-20.4-20.4-20.4z"
      />
      <path
        opacity="0.5"
        d="m146.3,125.8h219.5c11.3,0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4h-219.5c-11.3,0-20.4,9.1-20.4,20.4-0.1,11.3 9.1,20.4 20.4,20.4z"
      />
      <path
        opacity="0.3"
        d="m219.5,51.8h73.1c11.3,0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4h-73.1c-11.3,0-20.4,9.1-20.4,20.4-2.84217e-14,11.3 9.1,20.4 20.4,20.4z"
      />
    </svg>
  );
}
